import {
  Box,
  Button,
  Checkbox,
  InputBase,
  MenuItem,
  Select,
  Skeleton,
  Typography,
} from "@mui/material";
import HeaderSection from "./header-section";
import SearchSection from "./search-section";
import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "store/appHooks";
import { fetchAllManufacturerAction } from "slices/generalReducer";
import { setSearchManufacturerIds } from "slices/searchListingReducer";

const TractorFilterSection = ({
  onClose,
  selectionBox = false,
}: {
  onClose: any;
  selectionBox?: Boolean;
}) => {
  const dispatch = useAppDispatch();
  const { manufacturer }: any = useAppSelector((state) => state.generalReducer);
  const [copyData, setCopyData] = useState(manufacturer.data);

  const { searchManufacturerIds }: any = useAppSelector(
    (state) => state.searchListingReducer
  );
  const [selected, setSelected] = useState(searchManufacturerIds);

  useEffect(() => {
    if (!manufacturer.data.length) dispatch(fetchAllManufacturerAction());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const applyFilter = () => {
    dispatch(setSearchManufacturerIds(selected));
    onClose();
  };

  useEffect(() => {
    setCopyData(manufacturer.data);
  }, [manufacturer.data]);

  useEffect(() => {
    setSelected(searchManufacturerIds);
  }, [searchManufacturerIds]);

  if (selectionBox) {
    return (
      <Box sx={{ position: "relative" }}>
        <Select
          input={
            <InputBase
              placeholder="By Horse Power"
              sx={{
                border: "1px solid #E2E2E2",
                height: "56px",
                borderRadius: "10px",

                pl: "20px",
              }}
            />
          }
          label="By Horse Power"
          fullWidth
          IconComponent={(props) => {
            console.log(props);
            return (
              <img
                src="/assets/img/icons/arrow_down.svg"
                alt=""
                style={{ marginRight: "10px" }}
              />
            );
          }}
          onChange={({ target }: any) => {
            setSelected(target.value);
          }}
          multiple
          value={selected}
          onBlur={applyFilter}
          MenuProps={{
            style: {
              maxHeight: "350px",
            },
          }}
        >
          {manufacturer.data.map((t: any, index: number) => (
            <MenuItem value={t.id}>{t.name}</MenuItem>
          ))}
        </Select>
        {selected.length === 0 && (
          <Typography
            sx={{
              color: "#A2A2A2",
              fontSize: "15px",
              fontWeight: 400,
              position: "absolute",
              top: "17px",
              left: "20px",
            }}
          >
            Tractor
          </Typography>
        )}
      </Box>
    );
  }

  return (
    <Box
      sx={{
        width: "600px",
        // display: "grid",
        // gridTemplateRows: "1fr auto",
        minHeight: "100%",
      }}
    >
      <HeaderSection
        label="Tractor"
        disabledClearAll={!selected?.length}
        onClearAll={() => {
          setSelected([]);
        }}
        onClose={onClose}
      />
      <div style={{ height: "70vh", overflow: "auto", paddingBottom: "110px" }}>
        <SearchSection
          placeholder="Search tractor..."
          onChange={({ target }: any) => {
            if (!target.value) {
              setCopyData(manufacturer.data);
            } else {
              setCopyData(() =>
                manufacturer.data.filter((r: any) =>
                  r.name.toLowerCase().includes(target.value.toLowerCase())
                )
              );
            }
          }}
        />
        <Box
          sx={{
            px: "4%",

            display: "flex",
            flexDirection: "column",
            gap: "10px",

            // height: "69.5vh",
            overflow: "auto",
          }}
        >
          {!manufacturer.loading &&
            copyData.map((r: any) => (
              <Box
                sx={{
                  borderBottom: "1px solid #E9E9E9",
                  py: "10px",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "baseline",
                }}
              >
                <Typography
                  sx={{ fontWeight: 500, fontSize: "15px", lineHeight: "18px" }}
                >
                  {r.name}
                </Typography>
                <Checkbox
                  checked={selected.includes(r.id)}
                  onChange={({ target }) => {
                    if (target.checked) setSelected([...selected, r.id]);
                    else setSelected(selected.filter((b: any) => b !== r.id));
                  }}
                  sx={{ padding: "0px" }}
                  checkedIcon={
                    <img src="/assets/img/icons/checked.svg" alt="" />
                  }
                  icon={<img src="/assets/img/icons/unchecked.svg" alt="" />}
                />
              </Box>
            ))}

          {!manufacturer.loading && copyData.length === 0 && (
            <Box
              sx={{
                height: "60vh",
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
              }}
            >
              <img src="/assets/img/no-data-cat.png" alt="" width="60%" />
              <Typography
                sx={{
                  color: "#323232",
                  fontWeight: 700,
                  fontSize: "26px",
                  mt: "15px",
                }}
              >
                No Tractor Found
              </Typography>
            </Box>
          )}

          {manufacturer.loading &&
            [1, 2, 3, 4, 5].map(() => (
              <Box
                sx={{
                  py: "10px",
                }}
              >
                <Skeleton variant="rectangular" height="80px" width="100%" />
              </Box>
            ))}
        </Box>
      </div>
      <Box
        sx={{
          position: "absolute",
          bottom: 0,
          right: 0,
          left: 0,
          backgroundColor: "white",
          display: "flex",
          justifyContent: "flex-end",
          px: "4%",
          py: "15px",
        }}
      >
        {copyData.length > 0 && (
          <Button
            sx={{ height: "48px", borderRadius: "10px" }}
            variant="contained"
            onClick={applyFilter}
          >
            Apply Filter
          </Button>
        )}
      </Box>
    </Box>
  );
};

export default TractorFilterSection;
